import { useSelector } from "react-redux";
import Interface from "../../../components/DataCollection/Families/ByInterface/InterfaceView/Interface";
import Page404 from "../../../components/Page404/Page403";
import { CheckPermissions } from "../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import { selectUserData } from "../../../features/userSlice";

const InterfaceViewScreen = () => {
  const userData = useSelector(selectUserData);
  const hasFamiliesScreenPermission = CheckPermissions(
    userData?.data?.products?.data_collection,
    "businesse_advisor",
    "view_families",
  );

  return <>{!hasFamiliesScreenPermission ? <Page404 /> : <Interface />}</>;
};

export default InterfaceViewScreen;
